import { gql } from '@apollo/client'

export const UPDATE_BLOG_POST_MUTATION = gql`
  mutation updateBlogPost($id: ID!, $attributes: BlogPostInput!) {
    updateBlogPost(id: $id, attributes: $attributes) {
      id
      title
      subtitle
      content
      pinned
      categories
    }
  }
`
